import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import ExportJobs from './ExportJobs';

const ExportJobsWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES?.EXPORT_JOBS} component={ExportJobs} />
    </Switch>
  );
};

export default ExportJobsWrapper;
